import { Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import NewHomePage from './components/NewHomePage.jsx'
import RouteMeta from './components/RouteMeta.jsx'
import { LOCATION_PAGES, isInstallerRoute } from './seo-config.js'

// Code-split all non-homepage routes so the initial bundle only includes
// the homepage. Each route loads its own chunk on navigation.
const AirconRepairsPage = lazy(() => import('./pages/AirconRepairsPage.jsx'));
const AirconInstallationPage = lazy(() => import('./pages/AirconInstallationPage.jsx'));
const AirconServicingPage = lazy(() => import('./pages/AirconServicingPage.jsx'));
const AirconRegasPage = lazy(() => import('./pages/AirconRegasPage.jsx'));
const CommercialAirconPage = lazy(() => import('./pages/CommercialAirconPage.jsx'));
const EmergencyPage = lazy(() => import('./pages/EmergencyPage.jsx'));
const AboutPage = lazy(() => import('./pages/AboutPage.jsx'));
const ContactPage = lazy(() => import('./pages/ContactPage.jsx'));
const AirconsPage = lazy(() => import('./pages/AirconsPage.jsx'));
const ProductDetailPage = lazy(() => import('./pages/ProductDetailPage.jsx'));
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage.jsx'));
const TermsOfServicePage = lazy(() => import('./pages/TermsOfServicePage.jsx'));
const WarrantyPage = lazy(() => import('./pages/WarrantyPage.jsx'));
const ThankYouPage = lazy(() => import('./pages/ThankYouPage.jsx'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage.jsx'));

function HomePage() {
  return (
    <div className="min-h-screen">
      <NewHomePage />
    </div>
  )
}

function PageLoader() {
  return (
    <div role="status" aria-busy="true" aria-label="Loading page" style={{ minHeight: '60vh' }}>
      <div className="animate-pulse" style={{ width: 'min(1400px, 100% - 10%)', margin: '0 auto', padding: '96px 0' }}>
        <div style={{ height: 12, width: 96, borderRadius: 4, background: '#E3EBF0' }} />
        <div style={{ height: 44, width: '60%', maxWidth: 560, borderRadius: 4, background: '#E3EBF0', marginTop: 20 }} />
        <div style={{ height: 18, width: '45%', maxWidth: 420, borderRadius: 4, background: '#EDF2F6', marginTop: 18 }} />
        <div style={{ height: 18, width: '35%', maxWidth: 340, borderRadius: 4, background: '#EDF2F6', marginTop: 10 }} />
      </div>
    </div>
  );
}

export default function App() {
  return (
    <>
      <RouteMeta />
      <Suspense fallback={<PageLoader />}>
        <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/aircon-repairs" element={<AirconRepairsPage />} />
        <Route path="/aircon-installation" element={<AirconInstallationPage />} />
        <Route path="/aircon-servicing" element={<AirconServicingPage />} />
        <Route path="/aircon-regas" element={<AirconRegasPage />} />
        <Route path="/commercial-aircon" element={<CommercialAirconPage />} />
        <Route path="/emergency" element={<EmergencyPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/aircons" element={<AirconsPage />} />
        <Route path="/aircons/:slug" element={<ProductDetailPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/warranty" element={<WarrantyPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        {Object.entries(LOCATION_PAGES).map(([route, content]) => (
          isInstallerRoute(route)
            ? <Route key={route} path={route} element={<AirconInstallationPage content={content} />} />
            : <Route key={route} path={route} element={<AirconRepairsPage content={content} />} />
        ))}
        <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </>
  )
}
